<sbd-account-portal-frontend-rider-request
  [currentOpenQR]="concernedQuoteRequest"
  (moveBackEvent)="closeDrawer($event)"
  (requestSubmitted)="requestSubmittedEvent($event)"
></sbd-account-portal-frontend-rider-request>
